import { atomWithStorage } from "jotai/utils";

/** Maps article JSON filename (from article list) to URL slug from getArticleUrl(title). */
export const articleFilenameToSlugAtom = atomWithStorage<
  Record<string, string>
>("articleFilenameToSlugAtom", {}, undefined, { getOnInit: true });
